import {createContext} from 'react';

export const RefCollectContext = createContext(null);
